import { isEqual } from 'lodash';
import { FC, useCallback, useMemo } from 'react';

import ParamLabel from 'dashboard/components/WorkflowControlPanel/ParamLabel';
import { StepAdvancedConfigurationWithErrorHandlingPanel } from 'dashboard/components/WorkflowControlPanel/StepAdvancedConfigurationWithErrorHandlingPanel';
import ActionOutput from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ActionOutput';
import ActionSelectIA from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ActionSelect';
import ActionVersion from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ActionVersion';
import { ACTIONS_WITH_CUSTOM_ADVANCED_CONFIG } from 'dashboard/components/WorkflowControlPanel/StepConfigAction/constants';
import GetAnalyticsMetricV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/GetAnalyticsMetricV1';
import ParamsAddItemToListFaceV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsAddItemToListFaceV1';
import ParamsAddItemToListV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsAddItemToListV1';
import ParamsAttachObjectsV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsAttachObjectsV1';
import ParamsCalculateV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsCalculateV1';
import ParamsClearbitBusinessLookupV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsClearbitBusinessLookupV1';
import ParamsCoinbaseCheckCryptoRiskV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsCoinbaseCheckCryptoRiskV1';
import ParamsCopyTagsV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsCopyTagsV1';
import ParamsCreateCaseV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsCreateCaseV1';
import ParamsCreateDocumentGovernmentIdV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsCreateDocumentGovernmentIdV1';
import ParamsCreateInquiryV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsCreateInquiryV1';
import ParamsCreateSARV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsCreateSARV1';
import ParamsCreateTransactionV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsCreateTransactionV1';
import ParamsCreateVerificationV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsCreateVerificationV1';
import ParamsEvaluateCodeV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsEvaluateCodeV1';
import ParamsEvaluateCodeV2 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsEvaluateCodeV2';
import ParamsGPTGenerateMessageV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsGPTGenerateMessageV1';
import ParamsHttpRequestV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsHttpRequestV1';
import ParamsHubspotOAuthCreateObjectV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsHubspotOAuthCreateObjectV1';
import ParamsHubspotOAuthSearchObjectV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsHubspotOAuthSearchObjectV1';
import ParamsHubspotOAuthUpdateObjectV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsHubspotOAuthUpdateObjectV1';
import ParamsHubspotUpdateObjectV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsHubspotUpdateObject';
import ParamsLabelObjectV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsLabelObjectV1';
import ParamsLegacyDynamicFlowUpdateFields from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsLegacyDynamicFlowUpdateFields';
import ParamsListMatchV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsListMatchV1';
import ParamsMxCreateUserV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsMxCreateUserV1';
import ParamsMxGetMicrodepositStatusV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsMxGetMicrodepositStatusV1';
import ParamsMxRequestConnectWidgetV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsMxRequestConnectWidgetV1';
import ParamsNovaCreditCashAtlasV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsNovaCreditCashAtlasV1';
import ParamsNovaCreditCreditPassportV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsNovaCreditCreditPassportV1';
import ParamsQueryV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsQueryV1';
import ParamsRedactObjectV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsRedactObjectV1';
import ParamsRemoveItemFromListV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsRemoveItemFromListV1';
import ParamsRemoveTagV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsRemoveTagV1';
import ParamsResolveCaseV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsResolveCaseV1';
import ParamsRouteInquiryStepV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsRouteInquiryStepV1';
import ParamsRunGraphQueryV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsRunGraphQueryV1';
import ParamsRunHttpPlatformIntegrationV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsRunHttpPlatformIntegrationV1';
import ParamsRunReportGenericV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsRunReportGenericV1';
import ParamsRunReportV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsRunReportV1';
import ParamsRunReportWithParamsV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsRunReportWithParamsV1';
import ParamsRunVerificationGenericV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsRunVerificationGenericV1';
import ParamsSalesforceCreateObjectV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsSalesforceCreateObjectV1';
import ParamsSalesforceOAuthCreateRecordV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsSalesforceOAuthCreateRecordV1';
import ParamsSalesforceOAuthSearchRecordV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsSalesforceOAuthSearchRecordV1';
import ParamsSalesforceOAuthUpdateRecordV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsSalesforceOAuthUpdateRecordV1';
import ParamsSalesforceUpdateObjectV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsSalesforceUpdateObjectV1';
import ParamsScheduleWorkflowRunV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsScheduleWorkflowRunV1';
import ParamsSendCaseMessageV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsSendCaseMessageV1';
import ParamsSendEmailV1, {
  defaultParamsSendEmail,
} from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsSendEmailV1';
import ParamsSendSlackMessageV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsSendSlackMessageV1';
import ParamsSetCaseSlaV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsSetCaseSlaV1';
import ParamsSetRelationV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsSetRelationV1';
import ParamsSlackOAuthSendMessageV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsSlackOAuthSendMessageV1';
import ParamsSmsInquiryLinkV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsSmsInquiryLinkV1';
import ParamsTagObjectV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsTagObjectV1';
import ParamsTrustDeviceFromInquiryV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsTrustDeviceFromInquiryV1';
import ParamsUnsetRelationV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsUnsetRelationV1';
import ParamsUpdateAccountFromUserInputV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsUpdateAccountFromUserInputV1';
import ParamsUpdateAccountV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsUpdateAccountV1';
import ParamsUpdateCaseStatusV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsUpdateCaseStatusV1';
import ParamsUpdateInquiryFieldsFromVerification from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsUpdateInquiryFieldsFromVerification';
import ParamsUpdateObjectV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsUpdateObjectV1';
import ParamsZendeskAddTagsToTicketV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsZendeskAddTagsToTicketV1';
import ParamsZendeskCreateTicketV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsZendeskCreateTicketV1';
import ParamsZendeskOAuthCreateTicketV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsZendeskOAuthCreateTicketV1';
import ParamsZendeskOAuthUpdateTicketV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsZendeskOAuthUpdateTicketV1';
import ParamsZendeskRemoveTagsFromTicketV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsZendeskRemoveTagsFromTicketV1';
import ParamsZendeskUpdateTicketV1 from 'dashboard/components/WorkflowControlPanel/StepConfigAction/ParamsZendeskUpdateTicketV1';
import RjsfActionBuilder from 'dashboard/components/WorkflowControlPanel/StepConfigAction/RjsfActionBuilder';
import {
  ACTION_TO_REQUIRED_REPORT_TEMPLATE_ID,
  getActionKeysForInputStep,
  getActionKeyToMetaDataMap,
  getActionMetaDataFromGenericConfigs,
} from 'dashboard/components/WorkflowControlPanel/StepConfigAction/selectActionUtils';
import { useWorkflowActionMeta } from 'dashboard/components/WorkflowEditor/WorkflowActionMetaProvider/WorkflowActionMetaProvider';
import {
  caseAttachmentsFor,
  filterUsableObjects,
  snakify,
  UsableObjectConfig,
} from 'dashboard/lib/workflows';
import { DEFAULT_EXPRESSION } from 'dashboard/lib/workflows/expression';
import { TemplateFilter } from 'dashboard/lib/workflows/objects';
import { Graph } from 'dashboard/models/graph';
import { Organization, ProductFeatureName } from 'dashboard/models/organization';
import { REPORT_TEMPLATE_TYPE_TO_FIELDS, ReportTemplate } from 'dashboard/models/report-template';
import { BaseTrigger, BaseTriggerParams, Trigger } from 'dashboard/models/trigger';
import {
  WorkflowActionMeta,
  WorkflowError,
  WorkflowFieldKey,
  WorkflowFieldObjectKey,
  WorkflowSchema,
} from 'dashboard/models/workflow';
import { GenericWorkflowAction } from 'dashboard/models/workflow-schema';
import { WorkflowRunStepAction } from 'dashboard/models/workflow-step';
import {
  ACTIONS_THAT_CREATE_EXTERNAL_INTEGRATION_REPORTS,
  AllWorkflowAction,
  DeprecatedWorkflowStepActionKey,
  HttpPlatformIntegrationConfig,
  NullWorkflowStepActionKey,
  StaticWorkflowAction,
  WorkflowAction,
  WorkflowActionFromConfig,
  WorkflowActionRunHttpPlatformIntegrationV1,
  WorkflowStep,
  WorkflowStepAction,
  WorkflowStepActionKey,
  WorkflowStepInput,
  WorkflowTimeUnit,
  ZendeskSupportedTicketStatuses,
} from 'dashboard/models/workflow-version';
import Spacer from 'design-system/components/Spacer';
import { FieldSchemaType } from 'lib/fields';
import useFeatureFlag from 'lib/hooks/useFeatureFlag';
import useProductFeature from 'lib/hooks/useProductFeature';
import { ApiModel } from 'lib/interfaces/api';
import { JsonSchema, JsonSchemaTypes } from 'lib/json-schema';
import { assertNever } from 'lib/utils/types';
import { findPath, generateWorkflowToken } from 'lib/workflows';

interface StepConfigActionProps {
  editable: boolean;
  errors: WorkflowError[];
  organization: Organization;
  step: WorkflowStepAction;
  stepsConfig: WorkflowStep[];
  inputStep: WorkflowStepInput;
  workflowSchema: WorkflowSchema;
  usableObjects: UsableObjectConfig[];
  jsonSchema: JsonSchema;
  tokensToDisplayValue: Record<string, string>;
  hasWorkflowsEnhanced: boolean;
  hasWorkflowsFree: boolean;
  hasWorkflowsBasic: boolean;
  workflowRunStep: WorkflowRunStepAction;
  focusStep: (token: string) => void;
  updateStep: (newStep: WorkflowStep, skipContext?: boolean, template?: TemplateFilter) => void;
}

const StepConfigAction: FC<StepConfigActionProps> = ({
  editable,
  organization,
  step,
  stepsConfig,
  inputStep,
  workflowSchema,
  usableObjects,
  jsonSchema,
  tokensToDisplayValue,
  workflowRunStep,
  hasWorkflowsFree,
  hasWorkflowsBasic,
  hasWorkflowsEnhanced,
  errors,
  focusStep,
  updateStep,
}) => {
  const { trigger } = inputStep;
  const pathToAction = useMemo(() => findPath(step.token, stepsConfig), [step.token, stepsConfig]);
  const actionMeta = useWorkflowActionMeta();
  return (
    <>
      <ActionSelect
        actionMeta={actionMeta}
        currentStep={step}
        editable={editable}
        inputStep={inputStep}
        usableObjects={usableObjects}
        updateStep={updateStep}
        hasWorkflowsFree={hasWorkflowsFree}
        hasWorkflowsBasic={hasWorkflowsBasic}
        hasWorkflowsEnhanced={hasWorkflowsEnhanced}
        workflowSchema={workflowSchema}
      />
      <ActionVersion
        action={step.action as StaticWorkflowAction}
        editable={editable}
        trigger={trigger}
        updateAction={(newAction) => {
          updateStep({
            ...step,
            action: newAction,
          });
        }}
      />
      <ActionConfiguration
        actionMeta={actionMeta}
        currentStep={step}
        editable={editable}
        errors={errors}
        focusStep={focusStep}
        organization={organization}
        pathToAction={pathToAction}
        trigger={trigger}
        updateStep={updateStep}
        workflowSchema={workflowSchema}
        usableObjects={usableObjects}
        jsonSchema={jsonSchema}
        tokensToDisplayValue={tokensToDisplayValue}
      />
      {!ACTIONS_WITH_CUSTOM_ADVANCED_CONFIG.includes(step.action.key as WorkflowStepActionKey) && (
        <>
          <Spacer height={2} />
          <StepAdvancedConfigurationWithErrorHandlingPanel
            step={step}
            trigger={trigger}
            updateStep={updateStep}
            disabled={!editable}
          />
        </>
      )}
      <ActionOutput currentStep={step} workflowRunStep={workflowRunStep} />
    </>
  );
};

// Infers type of 'params' of WorkflowAction from WorkflowStepActionKey
type ParamsTypeForWorkflowAction<
  T extends WorkflowStepActionKey,
  S extends WorkflowAction = WorkflowAction,
> = S extends { key: T; params: infer P } ? P : never;

const ActionSelect = ({
  actionMeta,
  currentStep,
  editable,
  inputStep,
  usableObjects,
  updateStep,
  hasWorkflowsEnhanced,
  hasWorkflowsBasic,
  hasWorkflowsFree,
  workflowSchema,
}: {
  actionMeta: WorkflowActionMeta;
  currentStep: WorkflowStepAction;
  editable: boolean;
  inputStep: WorkflowStepInput;
  usableObjects: UsableObjectConfig[];
  hasWorkflowsEnhanced: boolean;
  hasWorkflowsFree: boolean;
  hasWorkflowsBasic: boolean;
  workflowSchema: WorkflowSchema;
  updateStep: (newStep: WorkflowStep) => void;
}) => {
  const { trigger } = inputStep;
  const actionMetaDataMap = getActionKeyToMetaDataMap(actionMeta);
  const genericActionMetaData = getActionMetaDataFromGenericConfigs(
    workflowSchema['generic-workflow-actions'],
  );

  const accountStatusActionEnabled = useFeatureFlag('dashboard:workflows-account-status-action');

  const chainalysisAddressScreeningEnabled = useFeatureFlag(
    'dashboard:enable-workflows-v2-chainalysis-address-screening-action',
  );
  const coinbaseCheckCryptoRiskEnabled = useFeatureFlag(
    'dashboard:enable-workflows-v2-coinbase-check-crypto-risk-action',
  );
  const equifaxOneviewEnabled = useFeatureFlag(
    'dashboard:enable-workflows-v2-equifax-oneview-action',
  );
  const evaluateCodeEnabled = useFeatureFlag('dashboard:enable-workflows-v2-custom-code-action');

  const labelObjectActionEnabled = useFeatureFlag('dashboard:enable-workflows-label-object-action');

  const novaCreditCashAtlasActionEnabled = useFeatureFlag(
    'dashboard:enable-workflows-v2-nova-credit-cash-atlas-action',
  );

  const novaCreditCreditPassportEnabled = useFeatureFlag(
    'dashboard:enable-workflows-v2-nova-credit-credit-passport-action',
  );

  const clearbitActionEnabled = useFeatureFlag(
    'dashboard:enable-workflows-v2-clearbit-business-lookup',
  );

  const sentilinkScoresEnabled = useFeatureFlag(
    'dashboard:enable-workflows-v2-sentilink-scores-action',
  );

  const trmWalletScreeningEnabled = useFeatureFlag(
    'dashboard:enable-workflows-v2-trm-wallet-screening-action',
  );

  const setRelationEnabled = useFeatureFlag('dashboard:set-relation-action-step');

  const sarProductFeatureEnabled = useProductFeature(ProductFeatureName.SARsDashboard);
  const hasCaseMessages = useProductFeature(ProductFeatureName.CasesModulesMessages);
  const hasCasesBasic = useProductFeature(ProductFeatureName.CasesBasic);
  const hasCasesEnhanced = useProductFeature(ProductFeatureName.CasesEnhanced);
  const hasCasesEnterprise = useProductFeature(ProductFeatureName.CasesEnterprise);
  const hasReportsCreateEnabled = useProductFeature(ProductFeatureName.ReportsCreate);
  const hasDevicesTrustedEnabled = useProductFeature(ProductFeatureName.DevicesTrusted);

  const sendCaseMessageEnabled =
    hasCaseMessages || hasCasesBasic || hasCasesEnhanced || hasCasesEnterprise;

  const queryStepEnabled = useFeatureFlag('dashboard:enable-workflows-query-step');

  const standardizeIdDetailsEnabled = useFeatureFlag(
    'dashboard:enable-workflows-standardize-id-details-v1',
  );

  const verificationCertificateKoreaEnabled = useFeatureFlag(
    'dashboard:ite-verification-certificate-korea',
  );

  const verificationDatabaseAadhaarEnabled = useFeatureFlag(
    'dashboard:ite-verification-database-aadhaar',
  );

  const verificationDigitalIdFinnishTrustNetworkEnabled = useProductFeature(
    ProductFeatureName.VerificationsDigitalIdFinnishTrustNetwork,
  );

  const verificationDigitalIdOneIdEnabled = useProductFeature(
    ProductFeatureName.VerificationsDigitalIdOneId,
  );

  const verificationDigitalIdSingpassEnabled = useFeatureFlag(
    'dashboard:ite-verification-digital-id-singpass',
  );

  const verificationDigitalIdUkSharecodeEnabled = useProductFeature(
    ProductFeatureName.VerificationsDigitalIdUkSharecode,
  );

  const createDocumentGovIdEnabled = useFeatureFlag(
    'dashboard:workflows-create-document-gov-id-action',
  );

  const pauseReportsContinuousMonitoringEnabled = useFeatureFlag(
    'dashboard:workflows-pause-continuous-monitoring-action',
  );

  const filterOldReports = (action: WorkflowStepActionKey) =>
    !Object.keys(ACTION_TO_REQUIRED_REPORT_TEMPLATE_ID).includes(action);

  // includes both feature flagged and product feature gated actions
  const featureManagedActions = (action: WorkflowStepActionKey) => {
    const actionToEnabledState: Record<string, boolean> = {
      [WorkflowStepActionKey.ChainalysisAddressScreening]: chainalysisAddressScreeningEnabled,
      [WorkflowStepActionKey.ClearbitBusinessLookup]: clearbitActionEnabled,
      [WorkflowStepActionKey.CoinbaseCheckCryptoRisk]: coinbaseCheckCryptoRiskEnabled,
      [WorkflowStepActionKey.EquifaxOneview]: equifaxOneviewEnabled,
      [WorkflowStepActionKey.EvaluateCode]: evaluateCodeEnabled || hasWorkflowsEnhanced,
      [WorkflowStepActionKey.LabelObject]: labelObjectActionEnabled,
      [WorkflowStepActionKey.NovaCreditCashAtlas]: novaCreditCashAtlasActionEnabled,
      [WorkflowStepActionKey.NovaCreditCreditPassport]: novaCreditCreditPassportEnabled,
      [WorkflowStepActionKey.Query]: queryStepEnabled,
      [WorkflowStepActionKey.RunReportSentilinkScores]: sentilinkScoresEnabled,
      [WorkflowStepActionKey.RunReportSentilinkApplicationRisk]: sentilinkScoresEnabled,
      [WorkflowStepActionKey.SetCaseSla]: hasCasesEnhanced || hasCasesEnterprise,
      [WorkflowStepActionKey.ClearCaseSla]: hasCasesEnhanced || hasCasesEnterprise,
      [WorkflowStepActionKey.SetRelation]: setRelationEnabled,
      [WorkflowStepActionKey.UnsetRelation]: setRelationEnabled,
      [WorkflowStepActionKey.TrmWalletScreening]: trmWalletScreeningEnabled,
      [WorkflowStepActionKey.TrustDeviceFromInquiry]: hasDevicesTrustedEnabled,
      [WorkflowStepActionKey.UpdateAccountStatus]: accountStatusActionEnabled,
      [WorkflowStepActionKey.CreateSAR]: sarProductFeatureEnabled,
      [WorkflowStepActionKey.AttachObjectsToSAR]: sarProductFeatureEnabled,
      [WorkflowStepActionKey.AutofillAttachedObjectsToSAR]: sarProductFeatureEnabled,
      [WorkflowStepActionKey.CreateVerificationCertificateKoreaFromInquiry]:
        verificationCertificateKoreaEnabled,
      [WorkflowStepActionKey.ProcessLatestVerificationCertificateKorea]:
        verificationCertificateKoreaEnabled,
      [WorkflowStepActionKey.CreateVerificationDatabaseAadhaarFromInquiry]:
        verificationDatabaseAadhaarEnabled,
      [WorkflowStepActionKey.ProcessLatestVerificationDatabaseAadhaar]:
        verificationDatabaseAadhaarEnabled,
      [WorkflowStepActionKey.CreateVerificationDigitalIdFinnishTrustNetworkFromInquiry]:
        verificationDigitalIdFinnishTrustNetworkEnabled,
      [WorkflowStepActionKey.ProcessLatestVerificationDigitalIdFinnishTrustNetwork]:
        verificationDigitalIdFinnishTrustNetworkEnabled,
      [WorkflowStepActionKey.CreateVerificationDigitalIdOneIdFromInquiry]:
        verificationDigitalIdOneIdEnabled,
      [WorkflowStepActionKey.ProcessLatestVerificationDigitalIdOneId]:
        verificationDigitalIdOneIdEnabled,
      [WorkflowStepActionKey.CreateVerificationDigitalIdSingpassFromInquiry]:
        verificationDigitalIdSingpassEnabled,
      [WorkflowStepActionKey.ProcessLatestVerificationDigitalIdSingpass]:
        verificationDigitalIdSingpassEnabled,
      [WorkflowStepActionKey.CreateVerificationDigitalIdUkSharecodeFromInquiry]:
        verificationDigitalIdUkSharecodeEnabled,
      [WorkflowStepActionKey.RunReportGeneric]: hasReportsCreateEnabled,
      [WorkflowStepActionKey.SendCaseMessage]: sendCaseMessageEnabled,
      [WorkflowStepActionKey.StandardizeIdDetails]: standardizeIdDetailsEnabled,
      [WorkflowStepActionKey.CreateDocumentGovernmentId]: createDocumentGovIdEnabled,
      [WorkflowStepActionKey.PauseReportsContinuousMonitoring]:
        pauseReportsContinuousMonitoringEnabled,
      // Deprecated
      [WorkflowStepActionKey.RunKyckrBusinessLookup]: false,
      [WorkflowStepActionKey.SubmitMiddeskBusinessLookup]: false,
    };

    return action in actionToEnabledState ? actionToEnabledState[action] : true;
  };

  const genericWorkflowActions = workflowSchema['generic-workflow-actions']
    .filter((action) => action.enabled)
    .filter(
      (action) =>
        filterOldReports(action.key as WorkflowStepActionKey) &&
        featureManagedActions(action.key as WorkflowStepActionKey),
    );
  let possibleActionKeys: AllWorkflowAction['key'][] = getActionKeysForInputStep(
    inputStep,
    actionMeta,
  )
    .filter(filterOldReports)
    .filter(featureManagedActions)
    .filter((key) => genericWorkflowActions.find((action) => action.key === key) == null);

  // For deprecated actions, we let the action key be visible as a form
  // option only if the current step has the deprecated action already
  // configured. This preserves backwards-compatibility by allowing the action
  // to be visible in the workflow runs page.
  if (
    Object.values(DeprecatedWorkflowStepActionKey).includes(
      currentStep.action.key as DeprecatedWorkflowStepActionKey,
    )
  ) {
    possibleActionKeys = [
      ...possibleActionKeys,
      currentStep.action.key as DeprecatedWorkflowStepActionKey,
    ];
  }

  const defaultReportFields = useCallback(
    (reportTemplate: ReportTemplate['type']) =>
      REPORT_TEMPLATE_TYPE_TO_FIELDS[reportTemplate].reduce<Record<string, string>>(
        (acc, field) => {
          const snakified = snakify(field);
          if (
            trigger?.type === ApiModel.TriggerEvent ||
            trigger?.type === ApiModel.TriggerSchedule ||
            trigger?.type === ApiModel.TriggerRecurring
          ) {
            acc[field] = [BaseTrigger, WorkflowFieldKey.Fields, snakified].join('.');
          } else if (trigger?.type === ApiModel.TriggerApi) {
            acc[field] = [BaseTriggerParams, WorkflowFieldKey.Fields, snakified].join('.');
          } else if (trigger?.type === ApiModel.TriggerCase) {
            acc[field] = [BaseTriggerParams, snakified].join('.');
          }
          return acc;
        },
        {},
      ),
    [trigger],
  );

  const defaultParams: (
    key: WorkflowAction['key'],
    version: WorkflowAction['version'],
  ) => ParamsTypeForWorkflowAction<WorkflowAction['key']> = useCallback(
    (key, version) => {
      const actionableCases = filterUsableObjects({
        usableObjects,
        options: {
          permittedObjects: [WorkflowFieldObjectKey.Case],
          excludeNonPersonaObjects: true,
        },
      });
      const DEFAULT_VARIABLE_ID = generateWorkflowToken();
      const pickTriggerIfTypeIs: (triggerTypes: Trigger['type'][]) => string = (triggerTypes) =>
        trigger && triggerTypes.includes(trigger.type) ? BaseTrigger : '';

      const params: ParamsTypeForWorkflowAction<WorkflowAction['key']> = {
        // These are covered by generic action so not used actually. Delete along with `WorkflowActionXyzV1` interface.
        [WorkflowStepActionKey.AddCaseToCaseQueue]: { case: '', 'case-queue-token': '' },
        [WorkflowStepActionKey.AddCommentToCase]: { case: '', comment: '' },
        [WorkflowStepActionKey.ApproveInquiry]: { inquiry: '' },
        [WorkflowStepActionKey.AssignCase]: {
          case: '',
          'assignee-type': 'individual' as const,
          'assignee-user-token': '',
          'assignment-policy-token': '',
        },
        [WorkflowStepActionKey.AttachObjects]: {
          target: '',
          objects: [],
        },
        [WorkflowStepActionKey.EmailInquiryLink]: {
          'email-address': '',
          body: '',
          cta: '',
          greeting: '',
          inquiry: '',
          subject: '',
        },
        [WorkflowStepActionKey.FindOrCreateAccount]: {
          'account-type-token': '',
          'identifier-key': '',
          'reference-id': '',
        },
        [WorkflowStepActionKey.FindOrCreateTransaction]: {
          'transaction-type-token': '',
          'identifier-key': '',
          'identifier-value': '',
        },
        [WorkflowStepActionKey.FetchPersonaObject]: {
          'object-type': ApiModel.Inquiry as const,
          id: '',
        },
        [WorkflowStepActionKey.SendSms]: { message: '', recipient: '' },
        [WorkflowStepActionKey.ClearCaseSla]: { case: '' },
        [WorkflowStepActionKey.PauseReportsContinuousMonitoring]: { object: '' },

        // not covered by generic action yet
        [WorkflowStepActionKey.AddItemToList]: { 'list-item-fields': {}, 'list-id': '' },
        [WorkflowStepActionKey.ListMatch]: { 'list-item-fields': {}, 'list-id': '' },
        [WorkflowStepActionKey.AddItemToListFace]: { object: '', 'list-id': '' },
        [WorkflowStepActionKey.RemoveItemFromList]: { 'list-item-fields': {}, 'list-id': '' },
        [WorkflowStepActionKey.Calculate]: {
          'return-variables': [DEFAULT_VARIABLE_ID],
          variables: [
            {
              id: DEFAULT_VARIABLE_ID,
              type: JsonSchemaTypes.Number as const,
              name: 'x0',
              value: DEFAULT_EXPRESSION,
            },
          ],
        },
        [WorkflowStepActionKey.CreateCase]: {
          'case-objects': caseAttachmentsFor(usableObjects).map(({ value }) => value),
          'case-template-token':
            actionMeta['case-templates'].length === 1 ? actionMeta['case-templates'][0].token : '',
          'case-fields': {},
        },
        [WorkflowStepActionKey.CreateInquiry]: {
          'template-id': '',
          'theme-id': '',
          account: '',
          'redirect-uri': '',
        },
        [WorkflowStepActionKey.CreateSAR]: {
          'sar-objects': [],
        },
        [WorkflowStepActionKey.CreateTransaction]: {
          'reference-id': '',
          'transaction-type-token':
            actionMeta['transaction-types'].length === 1
              ? actionMeta['transaction-types'][0].token
              : '',
          'transaction-fields': {},
        },
        [WorkflowStepActionKey.HttpRequest]: {
          url: '',
          method: 'POST' as const,
          body: '',
          'headers-v2': [],
          'persona-secret': '',
          'retry-intervals': [3, 60, 600, 3600, 14400, 46800, 118800, 259200],
          'return-schema': null,
          timeout: null,
        },
        [WorkflowStepActionKey.LabelObject]: {
          object: '',
        },
        [WorkflowStepActionKey.MxCreateUser]: {
          'external-integration-id': '',
          'user-id': '',
          metadata: '',
          email: '',
        },
        [WorkflowStepActionKey.MxGetMicrodepositStatus]: {
          'external-integration-id': '',
          'user-guid': '',
          'microdeposit-guid': '',
        },
        [WorkflowStepActionKey.MxRequestConnectWidget]: {
          'external-integration-id': '',
          'user-guid': '',
          'microdeposit-guid': '',
        },
        [WorkflowStepActionKey.TagObject]: {
          object: BaseTrigger,
          'tag-id': [],
        },
        [WorkflowStepActionKey.CopyTags]: {
          'from-object': '',
          'to-object': '',
        },
        [WorkflowStepActionKey.ConfirmLatestVerificationEmailAddress]: {
          inquiry: BaseTrigger,
          'max-attempts': '',
        },
        [WorkflowStepActionKey.RemoveTag]: {
          object: '',
          'tag-ids': [],
        },
        [WorkflowStepActionKey.Query]: {
          'object-type': ApiModel.Account as const,
          filters: [],
        },
        [WorkflowStepActionKey.ConfirmLatestVerificationPhoneNumber]: {
          inquiry: BaseTrigger,
          'max-attempts': '',
        },
        [WorkflowStepActionKey.CreateDocumentGovernmentId]: {
          objects: [],
          'verification-template-id': '',
          'verification-fields': {},
        },
        [WorkflowStepActionKey.CreateVerificationAamvaFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'verification-to-inquiry-field-mapping': {
            'identification-number': 'identification_number',
            'issuing-authority': 'issuing_authority',
            'issue-date': 'issue_date',
            'expiration-date': 'expiration_date',
            'name-first': 'name_first',
            'name-last': 'name_last',
            birthdate: 'birthdate',
            'address-postal-code': 'address_postal_code',
          },
        },
        [WorkflowStepActionKey.CreateVerificationCertificateKoreaFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'verification-to-inquiry-field-mapping': {
            'identification-number': 'identification_number',
            'name-first': 'name_first',
            'name-last': 'name_last',
          },
          'field-key-kica-flow-url': 'kica_flow_url',
        },
        [WorkflowStepActionKey.CreateVerificationDatabaseFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'verification-to-inquiry-field-mapping': {
            'name-first': 'name_first',
            'name-middle': 'name_middle',
            'name-last': 'name_last',
            birthdate: 'birthdate',
            'country-code': 'selected_country_code',
            'identification-number': 'identification_number',
            'address-street-1': 'address_street_1',
            'address-street-2': 'address_street_2',
            'address-city': 'address_city',
            'address-subdivision': 'address_subdivision',
            'address-postal-code': 'address_postal_code',
            'phone-number': 'phone_number',
            'email-address': 'email_address',
          },
        },
        [WorkflowStepActionKey.CreateVerificationDatabaseAadhaarFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'verification-to-inquiry-field-mapping': {
            'name-first': 'name_first',
            'name-last': 'name_last',
            birthdate: 'birthdate',
          },
          'field-key-aadhaar-flow-url': 'aadhaar_flow_url',
        },
        [WorkflowStepActionKey.CreateVerificationDatabaseStandardFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'verification-to-inquiry-field-mapping': {
            'name-first': 'name_first',
            'name-middle': 'name_middle',
            'name-last': 'name_last',
            birthdate: 'birthdate',
            'address-street-1': 'address_street_1',
            'address-street-2': 'address_street_2',
            'address-city': 'address_city',
            'address-subdivision': 'address_subdivision',
            'address-postal-code': 'address_postal_code',
            'country-code': 'selected_country_code',
            'phone-number': 'phone_number',
            'email-address': 'email_address',
          },
        },
        [WorkflowStepActionKey.CreateVerificationDatabaseEcbsvFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'verification-to-inquiry-field-mapping': {
            'identification-number': 'identification_number',
            'name-first': 'name_first',
            'name-middle': 'name_middle',
            'name-last': 'name_last',
            birthdate: 'birthdate',
          },
        },
        [WorkflowStepActionKey.CreateVerificationDigitalIdFinnishTrustNetworkFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'field-key-finnish-trust-network-flow-url': 'finnish_trust_network_flow_url',
        },
        [WorkflowStepActionKey.CreateVerificationDigitalIdOneIdFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'field-key-one-id-flow-url': 'one_id_flow_url',
        },
        [WorkflowStepActionKey.CreateVerificationDigitalIdSingpassFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
        },
        [WorkflowStepActionKey.CreateVerificationDigitalIdUkSharecodeFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'verification-to-inquiry-field-mapping': {
            sharecode: 'sharecode',
            birthdate: 'birthdate',
            'name-full-input': 'name_full_input',
          },
        },
        [WorkflowStepActionKey.CreateVerificationDocumentFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'field-key-document': 'current_document',
          'complete-on-tentative': true,
        },
        [WorkflowStepActionKey.CreateVerificationEmailAddressFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'verification-to-inquiry-field-mapping': {
            'email-address': 'email_address',
          },
          'from-step': '',
          'from-component': '',
        },
        [WorkflowStepActionKey.CreateVerificationGovernmentIdFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'field-key-document': 'current_government_id',
        },
        [WorkflowStepActionKey.CreateVerificationGovernmentIdNfcFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'field-key-document': 'nfc_data',
        },
        [WorkflowStepActionKey.CreateVerificationPhoneNumberFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'verification-to-inquiry-field-mapping': {
            'phone-number': 'phone_number',
          },
        },
        [WorkflowStepActionKey.CreateVerificationSelfieFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'field-key-selfie': 'current_selfie',
        },
        [WorkflowStepActionKey.EvaluateCode]: {
          'serialized-code': '',
          ...(version === 2
            ? {
                'input-args': {},
                'return-schema': {
                  type: FieldSchemaType.Json as const,
                  key: 'result',
                  label: 'Result',
                  config: {
                    'json-schema': JSON.stringify({ type: 'null' }),
                  },
                },
                timeout: null,
              }
            : {
                trigger: BaseTrigger,
                'return-type': 'void' as const,
                ...(trigger && [ApiModel.TriggerApi, ApiModel.TriggerCase].includes(trigger.type)
                  ? {
                      'trigger-params': 'trigger_params',
                    }
                  : {}),
              }),
        },
        [WorkflowStepActionKey.EquifaxOneview]: {
          object: pickTriggerIfTypeIs([ApiModel.TriggerEvent, ApiModel.TriggerCase]),
          'report-template-token': '',
          'report-fields': defaultReportFields(ApiModel.ReportTemplateEquifaxOneview),
          'report-template-type': ApiModel.ReportTemplateEquifaxOneview as const,
        },
        [WorkflowStepActionKey.ProcessLatestVerificationCertificateKorea]: {
          inquiry: BaseTrigger,
        },
        [WorkflowStepActionKey.ProcessLatestVerificationDatabaseAadhaar]: {
          inquiry: BaseTrigger,
        },
        [WorkflowStepActionKey.ProcessLatestVerificationDigitalIdFinnishTrustNetwork]: {
          inquiry: BaseTrigger,
        },
        [WorkflowStepActionKey.ProcessLatestVerificationDigitalIdOneId]: {
          inquiry: BaseTrigger,
        },
        [WorkflowStepActionKey.ProcessLatestVerificationDigitalIdSingpass]: {
          inquiry: BaseTrigger,
        },
        [WorkflowStepActionKey.SyncGraph]: {
          account: `${BaseTrigger}.${ApiModel.Account}`,
          'use-selective-sync': false,
          'selective-sync-graph-query-template-ids': [],
        },
        [WorkflowStepActionKey.NovaCreditCashAtlas]: {
          'input-fields': {
            object: pickTriggerIfTypeIs([ApiModel.TriggerEvent, ApiModel.TriggerCase]),
            'product-id': '',
            'public-token': '',
          },
        },
        [WorkflowStepActionKey.RunKyckrBusinessLookup]: {
          object: pickTriggerIfTypeIs([ApiModel.TriggerEvent, ApiModel.TriggerCase]),
          'report-fields': defaultReportFields(ApiModel.ReportTemplateKyckrBusinessLookup),
          'report-template-token': '',
          'report-template-type': ApiModel.ReportTemplateKyckrBusinessLookup as const,
        },
        [WorkflowStepActionKey.RedactObject]: {
          object: '',
          fields: [],
          'redact-all': true,
          'retention-period-days': 0,
        },
        [WorkflowStepActionKey.ResendConfirmationCodeLatestVerificationEmailAddress]: {
          inquiry: BaseTrigger,
          'from-step': '',
          'from-component': '',
        },
        [WorkflowStepActionKey.ResendConfirmationCodeLatestVerificationPhoneNumber]: {
          inquiry: BaseTrigger,
        },
        [WorkflowStepActionKey.RunGraphQuery]: {
          'graph-query-template-id':
            actionMeta['graph-query-templates'].length === 1
              ? actionMeta['graph-query-templates'][0].id
              : '',
          'query-inputs': {},
          'generate-snapshot': true,
          async: false,
          timeout: 0,
        },
        [WorkflowStepActionKey.RunReportAddressLookup]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportAdverseMedia]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportBusinessAdverseMedia]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportBusinessAssociatedPersons]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportBusinessClassification]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportBusinessIndustryClassification]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportBusinessLiensLookup]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportBusinessLookup]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportBusinessNonprofit]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportBusinessOnlinePresence]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportBusinessRegistrationsLookup]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportBusinessSocialMedia]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportBusinessWatchlist]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportBusinessWebsite]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportCryptoAddressWatchlist]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportCustomList]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportEmailAddress]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportGeneric]: {
          object: pickTriggerIfTypeIs([
            ApiModel.TriggerCase,
            ApiModel.TriggerDirect,
            ApiModel.TriggerEvent,
          ]),
          'report-fields': {},
          'report-template-token': '',
        },
        [WorkflowStepActionKey.RunReportPhoneNumber]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportPoliticallyExposedPerson]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportProfile]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportProfileNonAuthoritative]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportScreening]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportSocialMedia]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportSynthetic]: { object: BaseTrigger },
        [WorkflowStepActionKey.RunReportWatchlist]: { object: BaseTrigger },

        [WorkflowStepActionKey.RunReportWithParams]: {
          case: BaseTrigger,
          'account-id': '',
          'report-fields': {},
          'report-template-id': '',
        },
        [WorkflowStepActionKey.RunVerificationGeneric]: {
          object: pickTriggerIfTypeIs([
            ApiModel.TriggerCase,
            ApiModel.TriggerDirect,
            ApiModel.TriggerEvent,
          ]),
          'verification-fields': {},
          'verification-template-id': '',
          'verification-template-version-id': '',
          'verification-meta': {},
          // tentative verifications do not have final information and so we don't want to
          // complete the step with a tentative verification in most cases.
          'complete-on-tentative': false,
        },
        [WorkflowStepActionKey.ChainalysisAddressScreening]: {
          object: pickTriggerIfTypeIs([ApiModel.TriggerEvent, ApiModel.TriggerCase]),
          'report-fields': defaultReportFields(ApiModel.ReportTemplateChainalysisAddressScreening),
          'report-template-token': '',
          'report-template-type': ApiModel.ReportTemplateChainalysisAddressScreening as const,
        },
        [WorkflowStepActionKey.CoinbaseCheckCryptoRisk]: {
          'input-fields': {
            object: pickTriggerIfTypeIs([ApiModel.TriggerEvent, ApiModel.TriggerCase]),
            asset: '',
            address: '',
            'user-id': '',
            'partner-id': '',
          },
        },
        [WorkflowStepActionKey.ClearbitBusinessLookup]: {
          'input-fields': {
            object: pickTriggerIfTypeIs([ApiModel.TriggerEvent, ApiModel.TriggerCase]),
            'email-address': '',
          },
        },
        [WorkflowStepActionKey.MxAccount]: {
          object: pickTriggerIfTypeIs([ApiModel.TriggerEvent, ApiModel.TriggerCase]),
          'report-template-token': '',
          'report-fields': REPORT_TEMPLATE_TYPE_TO_FIELDS[ApiModel.ReportTemplateMxAccount].reduce<
            Record<string, string>
          >((acc, field) => {
            const base =
              trigger?.type === ApiModel.TriggerEvent || trigger?.type === ApiModel.TriggerDirect
                ? BaseTrigger
                : BaseTriggerParams;

            // Snakify field values and prepend
            // 'mx_bank_' to any GUID fields
            let mxField = snakify(field);
            if (field.includes('guid')) {
              mxField = 'mx_bank_' + mxField;
            }

            acc[field] = [base, WorkflowFieldKey.Fields, mxField].join('.');
            return acc;
          }, {}),
          'report-template-type': ApiModel.ReportTemplateMxAccount as const,
        },
        [WorkflowStepActionKey.NovaCreditCreditPassport]: {
          'input-fields': {
            object: pickTriggerIfTypeIs([ApiModel.TriggerEvent, ApiModel.TriggerCase]),
            'product-id': '',
            'public-token': '',
          },
        },
        [WorkflowStepActionKey.RunVerificationDatabaseBusiness]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'verification-to-inquiry-field-mapping': {
            'address-street-1': 'address_street_1',
            'address-street-2': 'address_street_2',
            'address-city': 'address_city',
            'address-subdivision': 'address_subdivision',
            'address-postal-code': 'address_postal_code',
            'address-country-code': 'address_country_code',
            'business-name': 'business_name',
            'registration-number': 'business_tax_identification_number',
          },
          // This is used in dynamic flow so we want to complete asap to not block the flow for the user
          'complete-on-tentative': true,
        },
        [WorkflowStepActionKey.RunVerificationDatabaseBusinessFootprintFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'verification-to-inquiry-field-mapping': {
            'address-street-1': 'address_street_1',
            'address-street-2': 'address_street_2',
            'address-city': 'address_city',
            'address-subdivision': 'address_subdivision',
            'address-postal-code': 'address_postal_code',
            'address-country-code': 'address_country_code',
            'business-name': 'business_name',
          },
        },
        [WorkflowStepActionKey.RunVerificationBusinessWebsiteFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'verification-to-inquiry-field-mapping': {
            'business-name': 'business_name',
            'website-url': 'website_url',
          },
        },
        [WorkflowStepActionKey.RunVerificationDatabasePhoneCarrierFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'verification-to-inquiry-field-mapping': {
            'phone-number': 'phone_number',
            'name-first': 'name_first',
            'name-last': 'name_last',
            birthdate: 'birthdate',
            'address-street-1': 'address_street_1',
            'address-street-2': 'address_street_2',
            'address-city': 'address_city',
            'address-subdivision': 'address_subdivision',
            'address-postal-code': 'address_postal_code',
            'country-code': 'selected_country_code',
          },
        },
        [WorkflowStepActionKey.RunVerificationDatabaseSerproFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'verification-to-inquiry-field-mapping': {
            birthdate: 'birthdate',
            'country-code': 'selected_country_code',
            cpf: 'cpf',
            'name-first': 'name_first',
            'name-last': 'name_last',
          },
        },
        [WorkflowStepActionKey.RunVerificationDatabaseTinFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'verification-to-inquiry-field-mapping': {
            'country-code': 'selected_country_code',
            'name-first': 'name_first',
            'name-last': 'name_last',
            'name-business': 'name_business',
            tin: 'identification_number',
          },
        },
        [WorkflowStepActionKey.RunVerificationDatabaseVatNumberFromInquiry]: {
          inquiry: BaseTrigger,
          'verification-template-version-id': '',
          'verification-to-inquiry-field-mapping': {
            'vat-number': 'vat_number',
            'country-code': 'country_code',
            'business-name': 'business_name',
            'address-street-1': 'address_street_1',
            'address-street-2': 'address_street_2',
            'address-city': 'address_city',
            'address-postal-code': 'address_postal_code',
            'address-subdivision': 'address_subdivision',
          },
        },
        [WorkflowStepActionKey.ScheduleWorkflowRun]: {
          'workflow-id': '',
          object: '',
          'input-fields': {},
          'time-offset': 0,
          'time-unit': WorkflowTimeUnit.Days,
        },
        [WorkflowStepActionKey.SendCaseMessage]: {
          'send-message-type': 'new' as const,
          'case-message-template-token': '',
          'to-email-addresses': [],
          'additional-cc-email-addresses': [],
        },
        [WorkflowStepActionKey.SendEmail]: defaultParamsSendEmail,
        [WorkflowStepActionKey.SendSlackMessage]: {
          url: '',
          message: '',
          override: '',
        },
        [WorkflowStepActionKey.SlackOAuthSendMessage]: {
          'external-integration-id': '',
          'recipient-type': 'user',
          'recipient-id': '',
          message: '',
        },
        [WorkflowStepActionKey.SmsInquiryLink]: {
          inquiry: '',
          message: '',
          'phone-number': '',
        },
        [WorkflowStepActionKey.RunReportSentilinkApplicationRisk]: {
          object: pickTriggerIfTypeIs([ApiModel.TriggerEvent, ApiModel.TriggerCase]),
          'report-template-token': '',
          'report-fields': defaultReportFields(ApiModel.ReportTemplateSentilinkApplicationRisk),
          'report-template-type': ApiModel.ReportTemplateSentilinkApplicationRisk as const,
        },
        [WorkflowStepActionKey.RunReportSentilinkScores]: {
          object: pickTriggerIfTypeIs([ApiModel.TriggerEvent, ApiModel.TriggerCase]),
          'report-template-token': '',
          'report-fields': defaultReportFields(ApiModel.ReportTemplateSentilinkScores),
          'report-template-type': ApiModel.ReportTemplateSentilinkScores as const,
        },
        [WorkflowStepActionKey.StandardizeIdDetails]: {
          verification: '',
        },
        [WorkflowStepActionKey.SubmitMiddeskBusinessLookup]: {
          object: pickTriggerIfTypeIs([ApiModel.TriggerEvent, ApiModel.TriggerCase]),
          'report-fields': defaultReportFields(ApiModel.ReportTemplateMiddeskBusinessLookup),
          'report-template-token': '',
          'report-template-type': ApiModel.ReportTemplateMiddeskBusinessLookup as const,
        },
        [WorkflowStepActionKey.TrmWalletScreening]: {
          object: pickTriggerIfTypeIs([ApiModel.TriggerEvent, ApiModel.TriggerCase]),
          'report-template-token': '',
          'report-fields': defaultReportFields(ApiModel.ReportTemplateTrmWalletScreening),
          'report-template-type': ApiModel.ReportTemplateTrmWalletScreening as const,
        },
        [WorkflowStepActionKey.TrustDeviceFromInquiry]: { inquiry: '' },
        [WorkflowStepActionKey.UpdateAccount]: {
          inquiry: BaseTrigger,
          account: `${BaseTrigger}.${ApiModel.Account}`,
          'input-fields': {},
        },
        [WorkflowStepActionKey.UpdateAccountFromUserInput]: {
          account: `${BaseTrigger}.${ApiModel.Account}`,
          'account-fields': {},
        },
        [WorkflowStepActionKey.UpdateAccountFieldsFromInquiry]: {
          inquiry: BaseTrigger,
          'account-to-inquiry-field-mapping': {
            'address-street-1': 'address_street_1',
            'address-street-2': 'address_street_2',
            'address-city': 'address_city',
            'address-subdivision': 'address_subdivision',
            'address-postal-code': 'address_postal_code',
            'country-code': 'address_country_code',
            birthdate: 'birthdate',
            'email-address': 'email_address',
            'identification-class': 'identification_class',
            'identification-number': 'identification_number',
            'name-first': 'name_first',
            'name-middle': 'name_middle',
            'name-last': 'name_last',
            'phone-number': 'phone_number',
          },
        },
        [WorkflowStepActionKey.SetCaseSla]: {
          case: actionableCases.length === 1 ? actionableCases[0].value : '',
          'sla-seconds': 172800,
        },
        [WorkflowStepActionKey.SetRelation]: {
          object: '',
          'relation-schema-name': '',
          'assigned-object': '',
        },
        [WorkflowStepActionKey.UnsetRelation]: {
          object: '',
          'relation-schema-name': '',
          'unset-object': '',
        },
        [WorkflowStepActionKey.UpdateCaseStatus]: {
          case: actionableCases.length === 1 ? actionableCases[0].value : '',
          'state-ids': [],
        },
        [WorkflowStepActionKey.UpdateInquiryNextStepName]: {
          inquiry: BaseTrigger,
          'next-step-name': '',
        },
        [WorkflowStepActionKey.UpdateInquiryFieldsFromVerificationDatabase]: {
          inquiry: BaseTrigger,
          verification: '',
          'inquiry-to-verification-field-mapping': {
            'address-street-1': 'address_street_1',
            'address-street-2': 'address_street_2',
            'address-city': 'address_city',
            'address-subdivision': 'address_subdivision',
            'address-postal-code': 'address_postal_code',
            'address-country-code': 'country_code',
            birthdate: 'birthdate',
            'identification-class': 'identification_class',
            'identification-number': 'identification_number',
            'name-first': 'name_first',
            'name-middle': 'name_middle',
            'name-last': 'name_last',
            'phone-number': 'phone_number',
            'email-address': 'email_address',
          },
        },
        [WorkflowStepActionKey.UpdateInquiryFieldsFromVerificationDatabaseStandard]: {
          inquiry: BaseTrigger,
          verification: '',
          'inquiry-to-verification-field-mapping': {
            'address-street-1': 'address_street_1',
            'address-street-2': 'address_street_2',
            'address-city': 'address_city',
            'address-subdivision': 'address_subdivision',
            'address-postal-code': 'address_postal_code',
            'address-country-code': 'country_code',
            birthdate: 'birthdate',
            'name-first': 'name_first',
            'name-middle': 'name_middle',
            'name-last': 'name_last',
            'phone-number': 'phone_number',
            'email-address': 'email_address',
          },
        },
        [WorkflowStepActionKey.UpdateInquiryFieldsFromVerificationDocument]: {
          inquiry: BaseTrigger,
          verification: '',
        },
        [WorkflowStepActionKey.UpdateInquiryFieldsFromVerificationGovernmentId]: {
          inquiry: BaseTrigger,
          verification: '',
          'inquiry-to-verification-field-mapping': {
            'address-street-1': 'address_street_1',
            'address-street-2': 'address_street_2',
            'address-city': 'address_city',
            'address-subdivision': 'address_subdivision',
            'address-postal-code': 'address_postal_code',
            'address-country-code': 'country_code',
            birthdate: 'birthdate',
            'identification-class': 'identification_class',
            'identification-number': 'identification_number',
            'name-first': 'name_first',
            'name-middle': 'name_middle',
            'name-last': 'name_last',
          },
        },
        [WorkflowStepActionKey.UpdateInquiryFromPersona]: {
          inquiry: BaseTrigger,
          'fields-mapping': {},
        },
        [WorkflowStepActionKey.UpdateInquiryStateDatabaseError]: {
          inquiry: BaseTrigger,
          verification: '',
        },
        [WorkflowStepActionKey.UpdateInquiryStateDocumentError]: {
          inquiry: BaseTrigger,
          verification: '',
        },
        [WorkflowStepActionKey.UpdateInquiryStateGovernmentIdError]: {
          inquiry: BaseTrigger,
          verification: '',
        },
        [WorkflowStepActionKey.UpdateInquiryStateSelfieError]: {
          inquiry: BaseTrigger,
          verification: '',
        },
        [WorkflowStepActionKey.UpdateObject]: {
          object: BaseTrigger,
          fields: {},
        },
        [WorkflowStepActionKey.ZendeskCreateTicket]: {
          'domain-url': '',
          'account-email': '',
          'api-token': '',
          subject: '',
          body: '',
          public: false,
          status: ZendeskSupportedTicketStatuses.DEFAULT,
          'add-tags': [],
        },
        [WorkflowStepActionKey.ZendeskOAuthCreateTicket]: {
          'external-integration-id': '',
          subject: '',
          body: '',
          'is-public': false,
          status: ZendeskSupportedTicketStatuses.DEFAULT,
          tags: [],
        },
        [WorkflowStepActionKey.ZendeskOAuthUpdateTicket]: {
          'external-integration-id': '',
          'ticket-id': '',
          body: '',
          'is-public': false,
          status: ZendeskSupportedTicketStatuses.DEFAULT,
          tags: [],
        },
        [WorkflowStepActionKey.ZendeskUpdateTicket]: {
          'domain-url': '',
          'account-email': '',
          'api-token': '',
          'ticket-id': '',
          body: '',
          public: false,
          status: ZendeskSupportedTicketStatuses.DEFAULT,
          'add-tags': [],
          'remove-tags': [],
        },
        [WorkflowStepActionKey.ZendeskAddTagsToTicket]: {
          'external-integration-id': '',
          'ticket-id': '',
          tags: [],
        },
        [WorkflowStepActionKey.ZendeskRemoveTagsFromTicket]: {
          'external-integration-id': '',
          'ticket-id': '',
          tags: [],
        },
        [WorkflowStepActionKey.HubspotOAuthCreateObject]: {
          'external-integration-id': '',
          'object-type': 'contacts',
          'object-properties': '{}',
          'associated-object-type': '',
          'associated-object-id': '',
        },
        [WorkflowStepActionKey.HubspotOAuthSearchObject]: {
          'external-integration-id': '',
          'object-type': 'contacts',
          'object-properties': '{}',
        },
        [WorkflowStepActionKey.HubspotOAuthUpdateObject]: {
          'external-integration-id': '',
          'object-type': 'contacts',
          'object-id': '',
          'object-properties': '{}',
          'associated-object-type': '',
          'associated-object-id': '',
          'skip-on-blank-value': true,
        },
        [WorkflowStepActionKey.HubspotUpdateObject]: {
          'access-token': '',
          'object-type': 'deals',
          'object-id': '',
          'object-properties': '{}',
        },
        [WorkflowStepActionKey.SalesforceCreateObject]: {
          'domain-url': '',
          'client-id': '',
          'client-secret': '',
          username: '',
          password: '',
          'object-type': 'Company',
          'object-properties': '{}',
        },
        [WorkflowStepActionKey.SalesforceOAuthCreateRecord]: {
          'external-integration-id': '',
          'record-type': '',
          'record-properties': '{}',
        },
        [WorkflowStepActionKey.SalesforceOAuthSearchRecord]: {
          'external-integration-id': '',
          'record-type': '',
          'record-properties': '{}',
        },
        [WorkflowStepActionKey.SalesforceOAuthUpdateRecord]: {
          'external-integration-id': '',
          'record-type': '',
          'record-id': '',
          'record-properties': '{}',
        },
        [WorkflowStepActionKey.SalesforceUpdateObject]: {
          'domain-url': '',
          'client-id': '',
          'client-secret': '',
          username: '',
          password: '',
          'object-type': 'Company',
          'object-id': '',
          'object-properties': '{}',
        },
        [WorkflowStepActionKey.GPTGenerateMessage]: {
          'external-integration-id': '',
          'gpt-model': 'gpt-3.5-turbo',
          prompt: '',
          'top-p': 1,
          'frequency-penalty': 0,
          'presence-penalty': 0,
          temperature: 0,
          'max-tokens': 256,
        },
        [WorkflowStepActionKey.SendConfirmationCode]: {
          verification: '',
        },
        [WorkflowStepActionKey.AttemptConfirmationCode]: {
          verification: '',
          'confirmation-code': '',
        },
      }[key];

      return params;
    },
    [usableObjects, trigger, actionMeta, defaultReportFields],
  );
  const possibleActions: AllWorkflowAction[] = useMemo(() => {
    const staticActions = possibleActionKeys.map((actionKey) => {
      const version = actionKey === WorkflowStepActionKey.EvaluateCode ? 2 : 1;

      const params = genericWorkflowActions.find((action) => action.key === actionKey)
        ? {}
        : defaultParams(actionKey as WorkflowAction['key'], version);

      return {
        key: actionKey,
        params,
        version,
      };
    });

    const genericActions = genericWorkflowActions.map((action) => {
      if (action.key === WorkflowStepActionKey.RunHttpPlatformIntegration) {
        return {
          key: action.key,
          params: {
            request_body: null,
            request_parameters: {},
            integration: (action as HttpPlatformIntegrationConfig).integration,
            integration_credential: (action as HttpPlatformIntegrationConfig)[
              'integration-configs'
            ][0]['value'],
          },
          version: 1,
        };
      } else {
        return {
          key: action.key,
          params: {},
          version: 1,
        };
      }
    });
    return staticActions.concat(genericActions);
  }, [defaultParams, genericWorkflowActions, possibleActionKeys]);

  const selectAction = <Action extends AllWorkflowAction>(selectedAction: Action) => {
    if (
      selectedAction.key === WorkflowStepActionKey.RunHttpPlatformIntegration &&
      currentStep.action.key === WorkflowStepActionKey.RunHttpPlatformIntegration
    ) {
      if (isEqual(selectedAction.params.integration, currentStep.action.params.integration)) {
        return;
      }
    } else if (selectedAction.key === currentStep.action.key) {
      return;
    }

    let name;
    if (selectedAction.key === WorkflowStepActionKey.RunHttpPlatformIntegration) {
      name =
        genericActionMetaData.find((metaData) =>
          isEqual(metaData.integration, selectedAction.params.integration),
        )?.label || '';
    } else {
      name = actionMetaDataMap[selectedAction.key].label;
    }

    // All (legacy) external integration reports use the run report generic wfs
    const key = ACTIONS_THAT_CREATE_EXTERNAL_INTEGRATION_REPORTS.includes(selectedAction.key)
      ? WorkflowStepActionKey.RunReportGeneric
      : selectedAction.key;

    updateStep({
      ...currentStep,
      name: name,
      action: {
        ...selectedAction,
        key: key,
      } as AllWorkflowAction,
    });
  };

  return (
    <>
      <ParamLabel htmlFor='action-select-input' labelText='Action' />
      <ActionSelectIA
        actionMetaDataMap={actionMetaDataMap}
        genericActionMetaData={genericActionMetaData}
        actions={possibleActions}
        trigger={trigger}
        disabled={!editable}
        value={currentStep.action}
        onActionSelect={selectAction}
        hasWorkflowsEnhanced={hasWorkflowsEnhanced}
        hasWorkflowsBasic={hasWorkflowsBasic}
        hasWorkflowsFree={hasWorkflowsFree}
      />
    </>
  );
};

const ActionConfiguration = ({
  actionMeta,
  currentStep,
  editable,
  errors,
  focusStep,
  organization,
  pathToAction,
  trigger,
  usableObjects,
  jsonSchema,
  tokensToDisplayValue,
  updateStep,
  workflowSchema,
}: {
  actionMeta: WorkflowActionMeta;
  currentStep: WorkflowStepAction;
  editable: boolean;
  errors: WorkflowError[];
  focusStep: (token: string) => void;
  organization: Organization;
  pathToAction: WorkflowStep[];
  trigger?: Trigger;
  usableObjects: UsableObjectConfig[];
  jsonSchema: JsonSchema;
  tokensToDisplayValue: Record<string, string>;
  updateStep: (newStep: WorkflowStep, skipContext?: boolean, template?: TemplateFilter) => void;
  workflowSchema: WorkflowSchema;
}) => {
  const updateActionParams = <Action extends StaticWorkflowAction>(
    params: Action['params'],
    template?: TemplateFilter,
  ) => {
    updateStep(
      {
        ...currentStep,
        action: {
          ...(currentStep.action as Action), // Giving more accurate type based on params
          params,
        },
      },
      false,
      template,
    );
  };

  const focusBackOnCurrentStep = () => {
    focusStep(currentStep.token);
  };
  const genericWorkflowActionsByKey = useMemo(() => {
    return workflowSchema['generic-workflow-actions'].reduce<
      Record<GenericWorkflowAction['key'], GenericWorkflowAction>
    >(
      (result, action) => ({
        ...result,
        [action.key]: action,
      }),
      {},
    );
  }, [workflowSchema]);

  // A placeholder action step has null for its action property
  if (currentStep.action.key === NullWorkflowStepActionKey.NullKey) return null;

  const isRunHttpPlatformIntegrationStep = (
    step: WorkflowStepAction,
  ): step is WorkflowStepAction<WorkflowActionRunHttpPlatformIntegrationV1> =>
    step.action.key === WorkflowStepActionKey.RunHttpPlatformIntegration;

  if (isRunHttpPlatformIntegrationStep(currentStep)) {
    const config = workflowSchema['generic-workflow-actions'].find((schema) => {
      return (
        schema.key === WorkflowStepActionKey.RunHttpPlatformIntegration &&
        isEqual(
          (schema as HttpPlatformIntegrationConfig).integration,
          currentStep.action.params.integration,
        )
      );
    }) as HttpPlatformIntegrationConfig | undefined;
    // TODO: If the generic workflow action no longer exists, render a non-editable list of the configuration
    if (config == null) {
      return null;
    }

    return (
      <ParamsRunHttpPlatformIntegrationV1
        step={currentStep}
        config={config}
        editable={editable}
        errors={errors}
        usableObjects={usableObjects}
        updateStep={updateStep}
      />
    );
  }

  if (genericWorkflowActionsByKey[currentStep.action.key]?.enabled) {
    const updateActionParams = (
      params: WorkflowActionFromConfig['params'],
      template?: TemplateFilter,
    ) => {
      updateStep(
        {
          ...currentStep,
          action: {
            ...(currentStep.action as WorkflowActionFromConfig),
            params,
          },
        },
        false,
        template,
      );
    };

    return (
      <RjsfActionBuilder
        workflowAction={genericWorkflowActionsByKey[currentStep.action.key]}
        actionParameters={currentStep.action.params as WorkflowActionFromConfig['params']}
        editable={editable}
        step={currentStep}
        usableObjects={usableObjects}
        jsonSchema={jsonSchema}
        tokensToDisplayValue={tokensToDisplayValue}
        actionMeta={actionMeta}
        errors={errors}
        updateActionParams={updateActionParams}
        updateStep={updateStep}
      />
    );
  }

  const action = currentStep.action as StaticWorkflowAction;
  switch (action.key) {
    case WorkflowStepActionKey.AttachObjects:
      return (
        <ParamsAttachObjectsV1
          step={currentStep}
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          updateStep={updateStep}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.AddItemToList:
      return (
        <ParamsAddItemToListV1
          step={currentStep}
          lists={actionMeta['lists']}
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
          updateStep={updateStep}
        />
      );
    case WorkflowStepActionKey.ListMatch:
      return (
        <ParamsListMatchV1
          step={currentStep}
          lists={actionMeta['lists']}
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
          updateStep={updateStep}
        />
      );
    case WorkflowStepActionKey.AddItemToListFace:
      return (
        <ParamsAddItemToListFaceV1
          lists={actionMeta['lists']}
          editable={editable}
          errors={errors}
          focusStep={focusStep}
          onMenuClose={focusBackOnCurrentStep}
          usableObjects={usableObjects}
          params={action.params}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.RemoveItemFromList:
      return (
        <ParamsRemoveItemFromListV1
          step={currentStep}
          lists={actionMeta['lists']}
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
          updateStep={updateStep}
        />
      );
    case WorkflowStepActionKey.Calculate:
      return (
        <ParamsCalculateV1
          editable={editable}
          errors={errors}
          usableObjects={usableObjects}
          params={action.params}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.CreateCase:
      return (
        <ParamsCreateCaseV1
          step={currentStep}
          caseTemplates={actionMeta['case-templates']}
          editable={editable}
          errors={errors}
          params={action.params}
          trigger={trigger}
          usableObjects={usableObjects}
          updateStep={updateStep}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.CreateDocumentGovernmentId:
      return (
        <ParamsCreateDocumentGovernmentIdV1
          verificationTemplates={actionMeta['verification-templates']}
          errors={errors}
          step={currentStep}
          updateStep={updateStep}
          editable={editable}
          params={action.params}
          trigger={trigger}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.CreateInquiry:
      return (
        <ParamsCreateInquiryV1
          step={currentStep}
          editable={editable}
          errors={errors}
          usableObjects={usableObjects}
          params={action.params}
          updateActionParams={updateActionParams}
          updateStep={updateStep}
          inquiryTemplates={actionMeta['inquiry-templates']}
          templates={actionMeta.templates}
          themes={actionMeta.themes}
          themeSets={actionMeta['theme-sets']}
          trigger={trigger}
        />
      );
    case WorkflowStepActionKey.CreateSAR:
      return (
        <ParamsCreateSARV1
          step={currentStep}
          editable={editable}
          updateStep={updateStep}
          errors={errors}
          usableObjects={usableObjects}
          params={action.params}
          trigger={trigger}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.CreateTransaction:
      return (
        <ParamsCreateTransactionV1
          transactionTypes={actionMeta['transaction-types']}
          editable={editable}
          errors={errors}
          usableObjects={usableObjects}
          params={action.params}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.CreateVerificationAamvaFromInquiry:
    case WorkflowStepActionKey.CreateVerificationCertificateKoreaFromInquiry:
    case WorkflowStepActionKey.CreateVerificationDatabaseAadhaarFromInquiry:
    case WorkflowStepActionKey.CreateVerificationDatabaseEcbsvFromInquiry:
    case WorkflowStepActionKey.CreateVerificationDatabaseFromInquiry:
    case WorkflowStepActionKey.CreateVerificationDatabaseStandardFromInquiry:
    case WorkflowStepActionKey.CreateVerificationDigitalIdFinnishTrustNetworkFromInquiry:
    case WorkflowStepActionKey.CreateVerificationDigitalIdOneIdFromInquiry:
    case WorkflowStepActionKey.CreateVerificationDigitalIdSingpassFromInquiry:
    case WorkflowStepActionKey.CreateVerificationDigitalIdUkSharecodeFromInquiry:
    case WorkflowStepActionKey.CreateVerificationDocumentFromInquiry:
    case WorkflowStepActionKey.CreateVerificationEmailAddressFromInquiry:
    case WorkflowStepActionKey.CreateVerificationGovernmentIdFromInquiry:
    case WorkflowStepActionKey.CreateVerificationGovernmentIdNfcFromInquiry:
    case WorkflowStepActionKey.CreateVerificationPhoneNumberFromInquiry:
    case WorkflowStepActionKey.CreateVerificationSelfieFromInquiry:
    case WorkflowStepActionKey.RunVerificationDatabaseBusiness:
    case WorkflowStepActionKey.RunVerificationDatabaseBusinessFootprintFromInquiry:
    case WorkflowStepActionKey.RunVerificationBusinessWebsiteFromInquiry:
    case WorkflowStepActionKey.RunVerificationDatabasePhoneCarrierFromInquiry:
    case WorkflowStepActionKey.RunVerificationDatabaseSerproFromInquiry:
    case WorkflowStepActionKey.RunVerificationDatabaseTinFromInquiry:
    case WorkflowStepActionKey.RunVerificationDatabaseVatNumberFromInquiry:
      return (
        <ParamsCreateVerificationV1
          step={currentStep}
          usableObjects={usableObjects}
          updateStep={updateStep}
          verificationTemplateVersions={actionMeta['verification-template-versions']}
          errors={errors}
          editable={editable}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.EvaluateCode:
      return action.version === 1 ? (
        <ParamsEvaluateCodeV1
          editable={editable}
          errors={errors}
          params={action.params}
          trigger={trigger}
          step={currentStep}
          updateStep={updateStep}
          updateActionParams={updateActionParams}
        />
      ) : (
        <ParamsEvaluateCodeV2
          step={currentStep}
          updateStep={updateStep}
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          trigger={trigger}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.HttpRequest:
      return (
        <ParamsHttpRequestV1
          step={currentStep}
          updateStep={updateStep}
          editable={editable}
          errors={errors}
          usableObjects={usableObjects}
          params={action.params}
          trigger={trigger}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.LabelObject:
      return (
        <ParamsLabelObjectV1
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.MxCreateUser:
      return (
        <ParamsMxCreateUserV1
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.MxGetMicrodepositStatus:
      return (
        <ParamsMxGetMicrodepositStatusV1
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.MxRequestConnectWidget:
      return (
        <ParamsMxRequestConnectWidgetV1
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.NovaCreditCashAtlas:
      return (
        <ParamsNovaCreditCashAtlasV1
          errors={errors}
          editable={editable}
          usableObjects={usableObjects}
          params={action.params}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.Query:
      return (
        <ParamsQueryV1
          editable={editable}
          errors={errors}
          params={action.params}
          workflowSchema={workflowSchema}
          updateActionParams={updateActionParams}
        />
      );
    case DeprecatedWorkflowStepActionKey.ResolveCase:
      return (
        <ParamsResolveCaseV1
          caseTemplates={actionMeta['case-templates']}
          errors={errors}
          editable={editable}
          focusStep={focusStep}
          onMenuClose={focusBackOnCurrentStep}
          pathToAction={pathToAction}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.RedactObject:
      return (
        <ParamsRedactObjectV1
          step={currentStep}
          updateStep={updateStep}
          actionMeta={actionMeta}
          editable={editable}
          errors={errors}
          focusStep={focusStep}
          onMenuClose={focusBackOnCurrentStep}
          usableObjects={usableObjects}
          params={action.params}
          trigger={trigger}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.UpdateInquiryNextStepName:
      return (
        <ParamsRouteInquiryStepV1
          steps={actionMeta['inquiry-template-version'].steps}
          step={currentStep}
          updateStep={updateStep}
          params={action.params}
          editable={editable}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.RunGraphQuery:
      return (
        <ParamsRunGraphQueryV1
          accountStatuses={actionMeta['account-statuses']}
          editable={editable}
          errors={errors}
          graph={actionMeta['graph'] as Graph}
          graphQueryTemplates={actionMeta['graph-query-templates']}
          params={action.params}
          pathToAction={pathToAction}
          step={currentStep}
          trigger={trigger}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
          updateStep={updateStep}
        />
      );
    case WorkflowStepActionKey.RunReportAddressLookup:
    case WorkflowStepActionKey.RunReportAdverseMedia:
    case WorkflowStepActionKey.RunReportBusinessAdverseMedia:
    case WorkflowStepActionKey.RunReportBusinessAssociatedPersons:
    case WorkflowStepActionKey.RunReportBusinessClassification:
    case WorkflowStepActionKey.RunReportBusinessIndustryClassification:
    case WorkflowStepActionKey.RunReportBusinessLiensLookup:
    case WorkflowStepActionKey.RunReportBusinessLookup:
    case WorkflowStepActionKey.RunReportBusinessNonprofit:
    case WorkflowStepActionKey.RunReportBusinessOnlinePresence:
    case WorkflowStepActionKey.RunReportBusinessRegistrationsLookup:
    case WorkflowStepActionKey.RunReportBusinessSocialMedia:
    case WorkflowStepActionKey.RunReportBusinessWatchlist:
    case WorkflowStepActionKey.RunReportBusinessWebsite:
    case WorkflowStepActionKey.RunReportCryptoAddressWatchlist:
    case WorkflowStepActionKey.RunReportCustomList:
    case WorkflowStepActionKey.RunReportEmailAddress:
    case WorkflowStepActionKey.RunReportPhoneNumber:
    case WorkflowStepActionKey.RunReportPoliticallyExposedPerson:
    case WorkflowStepActionKey.RunReportProfile:
    case WorkflowStepActionKey.RunReportProfileNonAuthoritative:
    case WorkflowStepActionKey.RunReportScreening:
    case WorkflowStepActionKey.RunReportSocialMedia:
    case WorkflowStepActionKey.RunReportSynthetic:
    case WorkflowStepActionKey.RunReportWatchlist:
    case DeprecatedWorkflowStepActionKey.CreateReportAdverseMedia:
    case DeprecatedWorkflowStepActionKey.CreateReportEmailAddress:
    case DeprecatedWorkflowStepActionKey.CreateReportPhoneNumber:
    case DeprecatedWorkflowStepActionKey.CreateReportProfile:
    case DeprecatedWorkflowStepActionKey.CreateReportSocialMedia:
    case DeprecatedWorkflowStepActionKey.CreateReportSynthetic:
    case DeprecatedWorkflowStepActionKey.CreateReportWatchlist:
      return (
        <ParamsRunReportV1
          editable={editable}
          errors={errors}
          focusStep={focusStep}
          onMenuClose={focusBackOnCurrentStep}
          params={action.params}
          trigger={trigger}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.RunReportGeneric: {
      const availableReportTemplates = action.params['report-template-type']
        ? actionMeta[action.params['report-template-type']]
        : actionMeta['report-templates'];
      return (
        <ParamsRunReportGenericV1
          reportTemplates={availableReportTemplates}
          errors={errors}
          step={currentStep}
          updateStep={updateStep}
          editable={editable}
          params={action.params}
          trigger={trigger}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    }
    case WorkflowStepActionKey.RunReportWithParams:
      return (
        <ParamsRunReportWithParamsV1
          step={currentStep}
          updateStep={updateStep}
          reportTemplates={actionMeta['report-templates']}
          errors={errors}
          trigger={trigger}
          editable={editable}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.RunVerificationGeneric:
      return (
        <ParamsRunVerificationGenericV1
          verificationTemplateVersions={actionMeta['verification-template-versions']}
          errors={errors}
          step={currentStep}
          updateStep={updateStep}
          editable={editable}
          params={action.params}
          trigger={trigger}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.CoinbaseCheckCryptoRisk:
      return (
        <ParamsCoinbaseCheckCryptoRiskV1
          errors={errors}
          editable={editable}
          usableObjects={usableObjects}
          params={action.params}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.ClearbitBusinessLookup:
      return (
        <ParamsClearbitBusinessLookupV1
          errors={errors}
          editable={editable}
          usableObjects={usableObjects}
          params={action.params}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.NovaCreditCreditPassport:
      return (
        <ParamsNovaCreditCreditPassportV1
          errors={errors}
          editable={editable}
          usableObjects={usableObjects}
          params={action.params}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.ScheduleWorkflowRun:
      return (
        <ParamsScheduleWorkflowRunV1
          workflows={actionMeta['workflows']}
          errors={errors}
          step={currentStep}
          updateStep={updateStep}
          editable={editable}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.SmsInquiryLink:
      return (
        <ParamsSmsInquiryLinkV1
          step={currentStep}
          updateStep={updateStep}
          editable={editable}
          errors={errors}
          organization={organization}
          params={action.params}
          trigger={trigger}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.SendCaseMessage:
      return (
        <ParamsSendCaseMessageV1
          caseTemplates={actionMeta['case-templates']}
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.SendEmail: {
      return (
        <ParamsSendEmailV1
          step={currentStep}
          updateStep={updateStep}
          editable={editable}
          errors={errors}
          params={action.params}
          trigger={trigger}
          updateActionParams={updateActionParams}
          usableObjects={usableObjects}
        />
      );
    }
    case WorkflowStepActionKey.SendSlackMessage:
      return (
        <ParamsSendSlackMessageV1
          step={currentStep}
          updateStep={updateStep}
          editable={editable}
          errors={errors}
          params={action.params}
          trigger={trigger}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.SlackOAuthSendMessage:
      return (
        <ParamsSlackOAuthSendMessageV1
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
          metaActionIntegrations={actionMeta['external-integrations']}
        />
      );
    case WorkflowStepActionKey.TagObject:
      return (
        <ParamsTagObjectV1
          editable={editable}
          errors={errors}
          focusStep={focusStep}
          onMenuClose={focusBackOnCurrentStep}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.RemoveTag:
      return (
        <ParamsRemoveTagV1
          editable={editable}
          errors={errors}
          focusStep={focusStep}
          onMenuClose={focusBackOnCurrentStep}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.CopyTags:
      return (
        <ParamsCopyTagsV1
          editable={editable}
          errors={errors}
          focusStep={focusStep}
          onMenuClose={focusBackOnCurrentStep}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.TrustDeviceFromInquiry:
      return (
        <ParamsTrustDeviceFromInquiryV1
          editable={editable}
          errors={errors}
          usableObjects={usableObjects}
          params={action.params}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.SetCaseSla:
      return (
        <ParamsSetCaseSlaV1
          token={currentStep.token}
          errors={errors}
          editable={editable}
          params={action.params}
          usableObjects={usableObjects}
          onMenuClose={focusBackOnCurrentStep}
          focusStep={focusStep}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.SetRelation:
      return (
        <ParamsSetRelationV1
          errors={errors}
          editable={editable}
          params={action.params}
          usableObjects={usableObjects}
          accountTypes={actionMeta['account-types']}
          transactionTypes={actionMeta['transaction-types']}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.UnsetRelation:
      return (
        <ParamsUnsetRelationV1
          step={currentStep}
          updateStep={updateStep}
          errors={errors}
          editable={editable}
          params={action.params}
          usableObjects={usableObjects}
          trigger={trigger}
          accountTypes={actionMeta['account-types']}
          transactionTypes={actionMeta['transaction-types']}
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.UpdateCaseStatus:
      return (
        <ParamsUpdateCaseStatusV1
          caseTemplates={actionMeta['case-templates']}
          errors={errors}
          editable={editable}
          focusStep={focusStep}
          onMenuClose={focusBackOnCurrentStep}
          pathToAction={pathToAction}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );

    case WorkflowStepActionKey.UpdateAccount:
      return (
        <ParamsUpdateAccountV1
          accountTypes={actionMeta['account-types']}
          step={currentStep}
          updateStep={updateStep}
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          trigger={trigger}
          updateActionParams={updateActionParams}
        />
      );

    case WorkflowStepActionKey.UpdateAccountFieldsFromInquiry:
      return (
        <ParamsLegacyDynamicFlowUpdateFields
          title='Account Fields'
          fieldsParamKey='account-to-inquiry-field-mapping'
          fieldMapping={action.params['account-to-inquiry-field-mapping']}
          usableObjects={usableObjects}
          errors={errors}
          editable={editable}
          updateFieldMapping={(fieldMapping) =>
            updateActionParams({
              ...action.params,
              ...fieldMapping,
            })
          }
        />
      );

    case WorkflowStepActionKey.UpdateAccountFromUserInput:
      return (
        <ParamsUpdateAccountFromUserInputV1
          step={currentStep}
          updateStep={updateStep}
          editable={editable}
          errors={errors}
          trigger={trigger}
          usableObjects={usableObjects}
          params={action.params}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.UpdateInquiryFieldsFromVerificationDatabase:
    case WorkflowStepActionKey.UpdateInquiryFieldsFromVerificationGovernmentId:
      return (
        <ParamsUpdateInquiryFieldsFromVerification
          action={action}
          errors={errors}
          editable={editable}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.UpdateObject:
      return (
        <ParamsUpdateObjectV1
          step={currentStep}
          updateStep={updateStep}
          editable={editable}
          errors={errors}
          trigger={trigger}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
          params={action.params}
        />
      );
    case WorkflowStepActionKey.ZendeskAddTagsToTicket:
      return (
        <ParamsZendeskAddTagsToTicketV1
          step={currentStep}
          updateStep={updateStep}
          externalIntegrations={actionMeta['external-integrations']}
          editable={editable}
          errors={errors}
          params={action.params}
          trigger={trigger}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.ZendeskCreateTicket:
      return (
        <ParamsZendeskCreateTicketV1
          step={currentStep}
          updateStep={updateStep}
          editable={editable}
          errors={errors}
          params={action.params}
          trigger={trigger}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.ZendeskOAuthCreateTicket:
      return (
        <ParamsZendeskOAuthCreateTicketV1
          step={currentStep}
          updateStep={updateStep}
          externalIntegrations={actionMeta['external-integrations']}
          editable={editable}
          errors={errors}
          params={action.params}
          trigger={trigger}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.ZendeskOAuthUpdateTicket:
      return (
        <ParamsZendeskOAuthUpdateTicketV1
          step={currentStep}
          updateStep={updateStep}
          externalIntegrations={actionMeta['external-integrations']}
          editable={editable}
          errors={errors}
          params={action.params}
          trigger={trigger}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.ZendeskRemoveTagsFromTicket:
      return (
        <ParamsZendeskRemoveTagsFromTicketV1
          step={currentStep}
          updateStep={updateStep}
          externalIntegrations={actionMeta['external-integrations']}
          editable={editable}
          errors={errors}
          params={action.params}
          trigger={trigger}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.ZendeskUpdateTicket:
      return (
        <ParamsZendeskUpdateTicketV1
          step={currentStep}
          updateStep={updateStep}
          editable={editable}
          errors={errors}
          params={action.params}
          trigger={trigger}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.HubspotOAuthCreateObject:
      return (
        <ParamsHubspotOAuthCreateObjectV1
          step={currentStep}
          editable={editable}
          errors={errors}
          updateStep={updateStep}
          params={action.params}
          trigger={trigger}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.HubspotOAuthSearchObject:
      return (
        <ParamsHubspotOAuthSearchObjectV1
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.HubspotOAuthUpdateObject:
      return (
        <ParamsHubspotOAuthUpdateObjectV1
          step={currentStep}
          editable={editable}
          errors={errors}
          params={action.params}
          updateStep={updateStep}
          trigger={trigger}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.HubspotUpdateObject:
      return (
        <ParamsHubspotUpdateObjectV1
          editable={editable}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.SalesforceCreateObject:
      return (
        <ParamsSalesforceCreateObjectV1
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.SalesforceOAuthCreateRecord:
      return (
        <ParamsSalesforceOAuthCreateRecordV1
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.SalesforceOAuthSearchRecord:
      return (
        <ParamsSalesforceOAuthSearchRecordV1
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.SalesforceOAuthUpdateRecord:
      return (
        <ParamsSalesforceOAuthUpdateRecordV1
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.SalesforceUpdateObject:
      return (
        <ParamsSalesforceUpdateObjectV1
          editable={editable}
          errors={errors}
          params={action.params}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.GPTGenerateMessage:
      return (
        <ParamsGPTGenerateMessageV1
          step={currentStep}
          updateStep={updateStep}
          editable={editable}
          errors={errors}
          params={action.params}
          trigger={trigger}
          usableObjects={usableObjects}
          updateActionParams={updateActionParams}
        />
      );
    case DeprecatedWorkflowStepActionKey.GetAnalyticsMetric:
      return (
        <GetAnalyticsMetricV1
          editable={editable}
          errors={errors}
          inquiryTemplates={actionMeta['inquiry-templates']}
          params={action.params}
          updateActionParams={updateActionParams}
        />
      );
    case WorkflowStepActionKey.ConfirmLatestVerificationEmailAddress:
    case WorkflowStepActionKey.ConfirmLatestVerificationPhoneNumber:
    case WorkflowStepActionKey.ProcessLatestVerificationCertificateKorea:
    case WorkflowStepActionKey.ProcessLatestVerificationDatabaseAadhaar:
    case WorkflowStepActionKey.ProcessLatestVerificationDigitalIdFinnishTrustNetwork:
    case WorkflowStepActionKey.ProcessLatestVerificationDigitalIdOneId:
    case WorkflowStepActionKey.ProcessLatestVerificationDigitalIdSingpass:
    case WorkflowStepActionKey.ResendConfirmationCodeLatestVerificationEmailAddress:
    case WorkflowStepActionKey.ResendConfirmationCodeLatestVerificationPhoneNumber:
    case WorkflowStepActionKey.UpdateInquiryFieldsFromVerificationDocument:
    case WorkflowStepActionKey.UpdateInquiryFieldsFromVerificationDatabaseStandard:
    case WorkflowStepActionKey.UpdateInquiryStateDatabaseError:
    case WorkflowStepActionKey.UpdateInquiryStateDocumentError:
    case WorkflowStepActionKey.UpdateInquiryStateGovernmentIdError:
    case WorkflowStepActionKey.UpdateInquiryStateSelfieError:
    case DeprecatedWorkflowStepActionKey.UpdateInquiryFieldsFromVerification:
    case WorkflowStepActionKey.UpdateInquiryFromPersona:
    case WorkflowStepActionKey.EquifaxOneview:
    case WorkflowStepActionKey.RunKyckrBusinessLookup:
    case WorkflowStepActionKey.SubmitMiddeskBusinessLookup:
    case WorkflowStepActionKey.RunReportSentilinkApplicationRisk:
    case WorkflowStepActionKey.RunReportSentilinkScores:
    case WorkflowStepActionKey.ChainalysisAddressScreening:
    case WorkflowStepActionKey.MxAccount:
    case WorkflowStepActionKey.TrmWalletScreening:
      return null; // No selectable configuration
    case WorkflowStepActionKey.AddCaseToCaseQueue:
    case WorkflowStepActionKey.AddCommentToCase:
    case WorkflowStepActionKey.ApproveInquiry:
    case WorkflowStepActionKey.AssignCase:
    case WorkflowStepActionKey.FindOrCreateAccount:
    case WorkflowStepActionKey.FindOrCreateTransaction:
    case WorkflowStepActionKey.EmailInquiryLink:
    case WorkflowStepActionKey.FetchPersonaObject:
    case WorkflowStepActionKey.ClearCaseSla:
    case WorkflowStepActionKey.SendSms:
    case WorkflowStepActionKey.SyncGraph:
    case WorkflowStepActionKey.SendConfirmationCode:
    case WorkflowStepActionKey.AttemptConfirmationCode:
    case WorkflowStepActionKey.PauseReportsContinuousMonitoring:
    case WorkflowStepActionKey.StandardizeIdDetails:
      return null; // These actions live as RJSF configs
    default:
      assertNever(action);
  }
};

export default StepConfigAction;
